import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "../../../Assets/Css/AddUpdateInvoice.scss";
import "react-toastify/dist/ReactToastify.css";
import { customStyle } from "../../../Components/Style";
import "../../../Assets/Css/AddUpdateShareHolder.scss";
import Select from "react-select";
import { Spinner } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from "formik";
import { connect } from "react-redux";
import moment from "moment";
import { addLeave, updateLeave } from "../../../Services/Leave/action";
import DatePicker from "react-datepicker";
import { listUsers } from '../../../Services/Users/action';
import { toast } from 'react-toastify';

const fullDayOptions = [
    { value: "full", label: "Full Day" },
    { value: "firstHalf", label: "First Half" },
    { value: "secondHalf", label: "Second Half" }
];

const multiDayOptions = [
    { value: "fullDays", label: "Full Days" },
    { value: "firstDaySecondHalf", label: "First Day (Second Half)" },
    { value: "lastDayFirstHalf", label: "Last Day (First Half)" }
];
const restrictedOptions = ["firstDaySecondHalf", "lastDayFirstHalf"];
const fullDaysValue = "fullDays";
import Swal from "sweetalert2";
const AddEditLeave = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const data = location?.state?.data?.allData;
    const [fileLinks, setFileLinks] = useState([]);
    const [selectedMultipleDates, setSelectedMultipleDates] = useState([]);
    const [selectedLeaveMode, setSelectedLeaveMode] = useState(null);
    const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
    useEffect(() => {
        props.listUsers();
    }, []);

    useEffect(() => {
        const storedFiles = JSON.parse(localStorage.getItem('fileLinks')) || [];
        setFileLinks(storedFiles);
    }, []);

    useEffect(() => {
        localStorage.setItem('fileLinks', JSON.stringify(fileLinks));
    }, [fileLinks]);

    const validateForm = () => {
        const isEmployee = props?.user?.role?.name === 'employee';
        const userName = isEmployee ? props?.user?.name : values?.employee?.label;
        if (!userName || userName.trim() === '' ||
            !selectFilters?.type || !selectFilters.type?.value ||
            !selectedMultipleDates || selectedMultipleDates.length === 0 || !selectedMultipleDates[0] ||
            !selectedLeaveMode || (Array.isArray(selectedLeaveMode) && selectedLeaveMode.length === 0) ||
            !values?.reason || values.reason.trim() === '') {
            toast.error('All fields are required');
            return false;
        }
        return true;
    };
    const handleOnSubmit = async () => {
        if (!validateForm()) {
            return;
        }
        try {
            let selectedDates = [];

            const [start, end] = selectedMultipleDates;

            const startDate = moment(start);
            const endDate = end ? moment(end) : moment(start);

            const dates = [];
            let current = startDate.clone();
            while (current.isSameOrBefore(endDate)) {
                dates.push(current.format("YYYY-MM-DD"));
                current.add(1, 'day');
            }
            selectedDates = dates;
            const calculateActualLeaveCount = () => {
                const totalDates = selectedDates.length;

                if (totalDates === 1) {

                    if (selectedLeaveMode?.value === "full") {
                        return 1;
                    } else if (selectedLeaveMode?.value === "firstHalf" || selectedLeaveMode?.value === "secondHalf") {
                        return 0.5;
                    }

                    return 1;
                } else {

                    let totalLeaveCount = 0;

                    if (Array.isArray(selectedLeaveMode)) {
                        const selectedValues = selectedLeaveMode.map(option => option.value);



                        if (selectedValues.includes("fullDays")) {

                            totalLeaveCount = totalDates;
                        } else {

                            let baseCount = totalDates;

                            if (selectedValues.includes("firstDaySecondHalf")) {

                                baseCount -= 0.5;
                            }

                            if (selectedValues.includes("lastDayFirstHalf")) {

                                baseCount -= 0.5;
                            }

                            totalLeaveCount = baseCount;
                        }
                    } else if (selectedLeaveMode?.value) {

                        const selectedValue = selectedLeaveMode.value;



                        if (selectedValue === "fullDays") {
                            totalLeaveCount = totalDates;
                        } else if (selectedValue === "firstDaySecondHalf") {

                            totalLeaveCount = 0.5 + (totalDates - 1);
                        } else if (selectedValue === "lastDayFirstHalf") {

                            totalLeaveCount = (totalDates - 1) + 0.5;
                        } else if (selectedValue === "full") {


                            totalLeaveCount = totalDates;
                        } else {

                            totalLeaveCount = totalDates;
                        }
                    } else {


                        totalLeaveCount = totalDates;
                    }


                    return totalLeaveCount;
                }
            };


            const actualLeaveCount = calculateActualLeaveCount();

            let availableCasualLeave = 0;
            if (props?.user?.role?.name === 'employee') {
                availableCasualLeave = parseFloat(props?.user?.casual_leave || 0);
            } else {
                const selectedEmployee = props?.users?.find(user => user?.id === values?.employee?.id);
                availableCasualLeave = parseFloat(selectedEmployee?.casual_leave || 0);
            }
            let originalCasualLeaveCount = 0;
            if (data) {
                let allLeaveRecords = [];

                if (typeof data === 'object' && !Array.isArray(data)) {
                    if (data.start_date || data.end_date || data.id) {
                        allLeaveRecords = [data];
                    } else {
                        allLeaveRecords = Object.values(data).filter(record => record && typeof record === 'object');
                    }
                } else if (Array.isArray(data)) {
                    allLeaveRecords = data;
                }


                allLeaveRecords.forEach(record => {
                    if (record.casual) {
                        originalCasualLeaveCount += parseFloat(record.casual) || 0;
                    }
                });
            }


            let effectiveAvailableCasual = availableCasualLeave + originalCasualLeaveCount;
            let totalAvailableCasual = effectiveAvailableCasual;


            const employeeId = props?.user?.role?.name === 'employee'
                ? props?.user?.id
                : values?.employee?.id;

            const body = {
                employee_id: employeeId,
                reason: values.reason,
                type: selectFilters?.type?.value,
                start_date: selectedDates[0],
                end_date: end ? selectedDates[selectedDates.length - 1] : selectedDates[0],
                duration: Array.isArray(selectedLeaveMode)
                    ? selectedLeaveMode.map((option) => option.value).join(',')
                    : selectedLeaveMode?.value,
                updateLocalUser: props?.user?.role?.name === 'employee' ? true : false
            }

            const proceedWithLeave = async () => {
                if (data) {
                    let leaveIds = [];

                    if (typeof data === 'object' && !Array.isArray(data)) {
                        if (data.start_date || data.end_date || data.id) {

                            if (data.id) {
                                leaveIds = [data.id];
                            }
                        } else {

                            const dataArray = Object.values(data).filter(record => record && typeof record === 'object' && record.id);
                            leaveIds = dataArray.map(leave => leave.id);
                        }
                    } else if (Array.isArray(data)) {

                        const validRecords = data.filter(leave => leave && typeof leave === 'object' && leave.id);
                        leaveIds = validRecords.map(leave => leave.id);
                    } else if (data.id) {

                        leaveIds = [data.id];
                    }


                    if (leaveIds.length > 0) {
                        await props?.updateLeave(leaveIds, body, navigate);
                    } else {

                        toast.error('Error: Invalid leave data');
                    }
                } else {

                    await props?.addLeave({ ...body, status: 'Pending' }, navigate);
                }
            };
            let showAvailableCasualLeave = data ? effectiveAvailableCasual : availableCasualLeave;




            if (selectFilters?.type?.value === "Casual" && actualLeaveCount > effectiveAvailableCasual) {
                const unpaidCount = actualLeaveCount - effectiveAvailableCasual;

                Swal.fire({
                    title: 'Leave Limit Exceeded',
                    html: `You have only <b>${showAvailableCasualLeave}</b> casual leaves.<br/><b>${unpaidCount}</b> of the selected leave(s) will be treated as <b>Unpaid</b>.<br/><br/>Do you want to proceed?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Yes, Proceed',
                    cancelButtonText: 'Cancel',
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await proceedWithLeave();
                    }
                });
            } else {
                Swal.fire({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, Apply',
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await proceedWithLeave();
                    }
                });
            }
        } catch (error) {
            console.error("Error in adding leave :", error);
        }
    }
    const Employees = props?.users?.map(item => {
        return {
            value: item?.name,
            label: item?.name,
            id: item?.id
        }
    })
    const getFirstLeaveRecord = () => {
        if (!data) return null;

        if (data?.user) {
            return data;
        }
        const firstKey = Object.keys(data)[0];
        return data[firstKey];
    };

    const firstLeaveRecord = getFirstLeaveRecord();


    const [selectFilters, setSelectedFilters] = useState({
        date: firstLeaveRecord ? firstLeaveRecord?.leave_date : null,
        status: [],
        type: leaveTypeOptions?.find(item => item?.value == firstLeaveRecord?.type) || [],
    });

    let initalVal = {
        employee: firstLeaveRecord ? Employees?.find(item => item?.value == firstLeaveRecord?.user?.name) : Employees?.find(item => item?.value == props?.user?.name) || [],
        reason: firstLeaveRecord ? firstLeaveRecord?.reason || '' : ''
    };


    let { values, errors, touched, handleChange, handleSubmit } = useFormik({
        initialValues: initalVal,
        enableReinitialize: true,
        onSubmit: handleOnSubmit
    });

    const getLeaveTypeOptions = () => {
        let casualLeaveBalance = 0;

        if (props?.user?.role?.name === 'employee') {
            casualLeaveBalance = parseFloat(props?.user?.casual_leave || 0);
        } else {
            if (values?.employee?.id) {
                const selectedEmployee = props?.users?.find(user => user?.id === values?.employee?.id);
                casualLeaveBalance = parseFloat(selectedEmployee?.casual_leave || 0);
            }
        }


        const baseOptions = casualLeaveBalance > 0 ? [
            { value: "Casual", label: "Casual" },
            { value: "Unpaid", label: "Unpaid" },
        ] : [
            { value: "Unpaid", label: "Unpaid" },
        ];


        if (data && firstLeaveRecord?.type) {
            const existingType = firstLeaveRecord.type;
            const typeExists = baseOptions.some(option => option.value === existingType);

            if (!typeExists) {
                if (existingType === "Casual") {
                    baseOptions.unshift({ value: "Casual", label: "Casual" });
                }
            }
        }

        if (data) {
            let totalCasual = 0;
            let allLeaveRecords = [];


            if (typeof data === 'object' && !Array.isArray(data)) {
                if (data.start_date || data.end_date || data.id) {
                    allLeaveRecords = [data];
                } else {
                    allLeaveRecords = Object.values(data).filter(record => record && typeof record === 'object');
                }
            } else if (Array.isArray(data)) {
                allLeaveRecords = data;
            }


            allLeaveRecords.forEach(record => {
                if (record.casual) {
                    totalCasual += parseFloat(record.casual) || 0;
                }
            });

            if (totalCasual > 0) {
                const casualExists = baseOptions.some(option => option.value === "Casual");
                if (!casualExists) {
                    baseOptions.unshift({ value: "Casual", label: "Casual" });
                }
            }
        }

        return baseOptions;
    };
    useEffect(() => {
        const newLeaveTypeOptions = getLeaveTypeOptions();
        setLeaveTypeOptions(newLeaveTypeOptions);
        if (firstLeaveRecord && newLeaveTypeOptions.length > 0) {
            const foundType = newLeaveTypeOptions.find(item => item?.value == firstLeaveRecord?.type);
            setSelectedFilters(prev => ({ ...prev, type: foundType || null }));
        }
    }, [values?.employee, props?.users, props?.user]);

    const isSameDay = (() => {
        const [start, end] = selectedMultipleDates;

        if (start && !end) {
            return true;
        }

        if (start && end && moment(start).isSame(moment(end), 'day')) {
            return true;
        }

        return false;
    })();
    useEffect(() => {
        if (data && leaveTypeOptions.length > 0) {
            let allLeaveRecords = [];

            if (typeof data === 'object' && !Array.isArray(data)) {
                if (data.start_date || data.end_date || data.id) {
                    allLeaveRecords = [data];
                } else {
                    allLeaveRecords = Object.values(data).filter(record => record && typeof record === 'object');
                }
            } else if (Array.isArray(data)) {
                allLeaveRecords = data;
            }

            if (allLeaveRecords.length > 0) {

                let leaveType = null;
                let totalCasual = 0;
                let totalUnpaid = 0;

                allLeaveRecords.forEach(record => {
                    if (record.casual) {
                        totalCasual += parseFloat(record.casual) || 0;
                    }
                    if (record.unpaid) {
                        totalUnpaid += parseFloat(record.unpaid) || 0;
                    }
                });

                if (totalCasual > 0 && totalUnpaid === 0) {
                    leaveType = "Casual";
                } else if (totalCasual === 0 && totalUnpaid > 0) {
                    leaveType = "Unpaid";
                } else if (totalCasual > 0 && totalUnpaid > 0) {
                    leaveType = "Casual";
                }

                if (leaveType) {
                    const foundTypeOption = leaveTypeOptions.find(option => option.value === leaveType);

                    if (foundTypeOption) {
                        setSelectedFilters(prev => ({ ...prev, type: foundTypeOption }));
                    } else {



                        const newOptions = getLeaveTypeOptions();


                        const retryFoundOption = newOptions.find(option => option.value === leaveType);
                        if (retryFoundOption) {
                            setLeaveTypeOptions(newOptions);
                            setSelectedFilters(prev => ({ ...prev, type: retryFoundOption }));
                        }
                    }
                }

                let allDates = [];

                allLeaveRecords.forEach(record => {
                    if (record && record.start_date) {
                        try {

                            const dateStr = record.start_date.includes(' ')
                                ? record.start_date.split(' ')[0]
                                : record.start_date;

                            const parsedDate = new Date(dateStr);
                            if (!isNaN(parsedDate.getTime())) {
                                allDates.push(parsedDate);
                            }
                        } catch (error) {
                            console.error("Error parsing date:", record.start_date, error);
                        }
                    }
                });



                if (allDates.length > 0) {

                    allDates.sort((a, b) => a - b);
                    const startDate = allDates[0];
                    const endDate = allDates[allDates.length - 1];



                    if (moment(startDate).isSame(moment(endDate), 'day')) {

                        setSelectedMultipleDates([startDate, null]);
                    } else {

                        setSelectedMultipleDates([startDate, endDate]);
                    }


                    const isSingleDay = moment(startDate).isSame(moment(endDate), 'day');

                    if (isSingleDay) {

                        let hasFirstHalf = false;
                        let hasSecondHalf = false;

                        allLeaveRecords.forEach(record => {
                            if (record.firstHalf === true) hasFirstHalf = true;
                            if (record.secondHalf === true) hasSecondHalf = true;
                        });

                        if (hasFirstHalf && hasSecondHalf) {

                            const fullDayOption = fullDayOptions.find(option => option.value === "full");
                            if (fullDayOption) {
                                setSelectedLeaveMode(fullDayOption);
                            }
                        } else if (hasFirstHalf && !hasSecondHalf) {

                            const firstHalfOption = fullDayOptions.find(option => option.value === "firstHalf");
                            if (firstHalfOption) {
                                setSelectedLeaveMode(firstHalfOption);
                            }
                        } else if (!hasFirstHalf && hasSecondHalf) {

                            const secondHalfOption = fullDayOptions.find(option => option.value === "secondHalf");
                            if (secondHalfOption) {
                                setSelectedLeaveMode(secondHalfOption);
                            }
                        }
                    } else {

                        const recordsByDate = {};

                        allLeaveRecords.forEach(record => {
                            const dateKey = record.start_date.split(' ')[0];
                            if (!recordsByDate[dateKey]) {
                                recordsByDate[dateKey] = { firstHalf: false, secondHalf: false };
                            }
                            if (record.firstHalf === true) recordsByDate[dateKey].firstHalf = true;
                            if (record.secondHalf === true) recordsByDate[dateKey].secondHalf = true;
                        });

                        const dateKeys = Object.keys(recordsByDate).sort();
                        const firstDate = dateKeys[0];
                        const lastDate = dateKeys[dateKeys.length - 1];

                        let selectedOptions = [];


                        const allFullDays = dateKeys.every(dateKey =>
                            recordsByDate[dateKey].firstHalf && recordsByDate[dateKey].secondHalf
                        );

                        if (allFullDays) {
                            const fullDaysOption = multiDayOptions.find(option => option.value === "fullDays");
                            if (fullDaysOption) {
                                selectedOptions.push(fullDaysOption);
                            }
                        } else {

                            if (!recordsByDate[firstDate].firstHalf && recordsByDate[firstDate].secondHalf) {
                                const firstDaySecondHalfOption = multiDayOptions.find(option => option.value === "firstDaySecondHalf");
                                if (firstDaySecondHalfOption) {
                                    selectedOptions.push(firstDaySecondHalfOption);
                                }
                            }

                            if (recordsByDate[lastDate].firstHalf && !recordsByDate[lastDate].secondHalf) {
                                const lastDayFirstHalfOption = multiDayOptions.find(option => option.value === "lastDayFirstHalf");
                                if (lastDayFirstHalfOption) {
                                    selectedOptions.push(lastDayFirstHalfOption);
                                }
                            }


                            if (selectedOptions.length === 0) {
                                const fullDaysOption = multiDayOptions.find(option => option.value === "fullDays");
                                if (fullDaysOption) {
                                    selectedOptions.push(fullDaysOption);
                                }
                            }
                        }

                        if (selectedOptions.length > 0) {
                            setSelectedLeaveMode(selectedOptions);
                        }
                    }
                }
            }
        }
    }, [data, leaveTypeOptions, props?.users, props?.user]);

    useEffect(() => {
        const [start, end] = selectedMultipleDates;
        const isCurrentlySameDay = start && !end || (start && end && moment(start).isSame(moment(end), 'day'));


        if (selectedLeaveMode) {
            const isSingleDayMode = ['full', 'firstHalf', 'secondHalf'].includes(selectedLeaveMode.value);
            const isMultipleDayMode = ['fullDays', 'firstDaySecondHalf', 'lastDayFirstHalf'].includes(selectedLeaveMode.value) || Array.isArray(selectedLeaveMode);

            if (isCurrentlySameDay && isMultipleDayMode) {

                setSelectedLeaveMode({ value: "full", label: "Full Day" });
            } else if (!isCurrentlySameDay && isSingleDayMode) {

                setSelectedLeaveMode({ value: "fullDays", label: "Full Days" });
            }
        }
    }, [selectedMultipleDates]);

    return (
        <div className="addUpdateShareholder-main">
            <div className="page-title">
                <h4>Assign Leave</h4>
                <div className="edit-btn">
                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={() => navigate(-1)}
                    >Cancel
                    </button>

                    <button
                        type="submit"
                        className="custom-btn"
                        onClick={handleSubmit}
                    >
                        {props.loading ? (
                            <Spinner
                                as="span"
                                animation="border"
                                className="custom-spinner"
                                role="status"
                                aria-hidden="true"
                            />
                        ) : (
                            'Save'
                        )}
                    </button>
                </div>
            </div>

            <div className="content-part">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="leave-card">
                            <div className="custom-row">
                                <div className="row">
                                    {/* name */}
                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <h6 className="label">Name<span className='required-field'> *</span></h6>
                                            {props?.user?.role?.name === 'employee' ?
                                                <input className="form-control w-full"
                                                    style={{
                                                        color: '#776e6e',
                                                        padding: '8px 12px',
                                                        borderRadius: '4px',
                                                        border: '1px solid #ced4da',
                                                        fontSize: '0.9rem',
                                                        transition: 'all 0.3s ease',
                                                        width: '100%',
                                                        cursor: 'not-allowed',
                                                        boxShadow: 'none',
                                                        backgroundColor: '#f1f1f1',
                                                        padding: '9px'
                                                    }}
                                                    type="text"
                                                    value={props?.user?.name || ''}
                                                    disabled
                                                    placeholder="--"
                                                />
                                                :
                                                <Select
                                                    value={values?.employee}
                                                    onChange={(data) => {
                                                        setSelectedFilters({ ...selectFilters, employee: data });
                                                        handleChange({
                                                            target: {
                                                                name: 'employee',
                                                                value: data
                                                            }
                                                        });
                                                    }}
                                                    options={Employees}
                                                    placeholder={"--"}
                                                    styles={customStyle}
                                                    theme={(theme) => ({
                                                        ...theme,
                                                        colors: {
                                                            ...theme.colors,
                                                            primary25: "#5757fe",
                                                            primary: "#5757fe",
                                                        },
                                                    })}
                                                />
                                            }
                                        </div>
                                    </div>

                                    {/* leave type */}
                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <div className="label">Leave Type <span className='required-field'> *</span> </div>
                                            <Select
                                                value={selectFilters.type}
                                                onChange={(data) =>
                                                    setSelectedFilters({ ...selectFilters, type: data })
                                                }
                                                options={leaveTypeOptions}
                                                placeholder={"--"}
                                                styles={customStyle}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-6"></div>

                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <div className="label">Date <span className='required-field'> *</span></div>
                                            <DatePicker
                                                selectsRange
                                                selected={selectedMultipleDates[0]}
                                                startDate={selectedMultipleDates[0]}
                                                endDate={selectedMultipleDates[selectedMultipleDates.length - 1]}
                                                placeholderText="Select Dates"
                                                onChange={(dates) => {
                                                    setSelectedMultipleDates(dates);
                                                }}
                                                disabled={props.loading}
                                                dateFormat="dd-MM-yyyy"
                                                maxDate={moment().add(2, 'months').toDate()}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                            <div className="label">Leave Duration <span className='required-field'> *</span></div>
                                            <Select
                                                value={selectedLeaveMode}
                                                onChange={(option) => setSelectedLeaveMode(option)}
                                                options={isSameDay ? fullDayOptions : multiDayOptions}
                                                placeholder="Select Duration"
                                                styles={customStyle}
                                                isDisabled={selectedMultipleDates.length < 1}
                                                isMulti={!isSameDay}
                                                isOptionDisabled={(option) => {
                                                    if (!isSameDay && Array.isArray(selectedLeaveMode)) {
                                                        const values = selectedLeaveMode.map((opt) => opt.value);
                                                        const isFullDaysSelected = values.includes(fullDaysValue);
                                                        const isRestrictedSelected = restrictedOptions.some(val => values.includes(val));

                                                        if (isFullDaysSelected && restrictedOptions.includes(option.value)) {
                                                            return true;
                                                        }
                                                        if (isRestrictedSelected && option.value === fullDaysValue) {
                                                            return true;
                                                        }
                                                    }
                                                    return false;
                                                }}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#5757fe",
                                                        primary: "#5757fe",
                                                    },
                                                })}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-4 col-md-6">
                                        <div className="input-group">
                                        </div>
                                    </div>

                                    <div className="col-lg-12 col-md-12">
                                        <div className="input-group">
                                            <div className="label">Reason <span className='required-field'> *</span></div>
                                            <textarea className="form-control" style={{ width: "100%" }} name="reason" value={values.reason} placeholder="e.g. Feeling not well." onChange={handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

const mapStateToProps = (state) => {
    return {
        loading: state.leaveReducer.loading,
        users: state.userReducer.users,
        user: state?.authenticationReducer?.user
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        addLeave: (data, navigate) => {
            dispatch(addLeave(data, navigate))
        },
        updateLeave: (id, data, navigate) => {
            dispatch(updateLeave(id, data, navigate))
        },
        listUsers: () => {
            dispatch(listUsers());
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(AddEditLeave);
